import React, { useEffect, useMemo } from "react";
import { withTranslation } from 'react-i18next';
import styles from './ReviewSummaryView.module.scss'
import { useSelector } from 'react-redux';
import { useHistory } from "react-router-dom";

import NewMailingAddressSummary from './NewMailingAddressSummary';

const NewAddressSummary = ({ t, i18n, setIsError }) => {
    const history = useHistory();
    const { apartment, city, postalCode, streetAddress } = useSelector((state) => state.app.newAddress);

    const { homeAddress, mailingAddress } = useSelector((state) => state.app.addressesToChange);
    useEffect(() => {
        try {
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }, [apartment, city, postalCode, streetAddress, setIsError])

    const { nsHealthCard, driverLicence, registeredByName, jointlyRegistered, registeredBusiness } = useSelector((state) => state.app.addressTypeChange)
    const isCivic = useMemo(() => {
        return !(nsHealthCard || driverLicence || registeredByName || jointlyRegistered) && registeredBusiness
    }, [driverLicence, nsHealthCard, registeredByName, jointlyRegistered, registeredBusiness]);

    const editNewAddressOnClick = () => {
        try {
            history.push(`/${i18n.language}${t('routes.new_address')}?isSummary=true`)
        } catch (e) {
            console.log(e)
            setIsError(true)
        }
    }

    return (

        <div className="row">
            <div className="col-xs-12 col-lg-8">
                <div className="col-xs-12">
                    <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
                        <div style={{ display: "flex", flexGrow: 1, justifyContent: "space-between", alignItems: "center" }}>
                            <div className="col-xs-6">

                                <h3>{t('review_summary.new_address')}</h3>
                            </div>
                            <div className="col-xs-6">

                                <a href="#" className={[styles['edit_button']].join(' ')}
                                    onClick={editNewAddressOnClick}
                                    value={t('jointly_owned_vehicle_summary.edit')} name={t('jointly_owned_vehicle_summary.edit')}>
                                    {/* <i aria-label={t('shared.edit')} className="fa fa-pencil" aria-hidden="true"></i> */}
                                    {t('jointly_owned_vehicle_summary.edit')}
                                </a>
                            </div>
                        </div>
                    </div>

                    {
                        homeAddress && (
                            <>
                                <br></br>

                                <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                                    {/* <div className="col-xs-6"><strong>{t('contact_information.full_name')}</strong></div> */}
                                    <div className="col-xs-6" style={{ lineBreak: "anywhere" }}><strong>{isCivic ? t('new_address.civic_address') : t('review_summary.home_address')}</strong></div>
                                </div>
                                <hr />

                                <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                                    <div className="col-xs-6"><strong>{t('current_address.street_address')}</strong></div>
                                    <div className="col-xs-6">{streetAddress}</div>
                                </div>

                                <hr />

                                <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                                    <div className="col-xs-6"><strong>{t('current_address.apartment')}</strong></div>
                                    <div className="col-xs-6">{apartment ? `${apartment}` : ''}</div>
                                </div>

                                <hr />

                                <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                                    <div className="col-xs-6"><strong>{t('current_address.city')}</strong></div>
                                    <div className="col-xs-6">{city}</div>
                                </div>

                                <hr />

                                <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                                    <div className="col-xs-6"><strong>{t('current_address.postal_code')}</strong></div>
                                    <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{postalCode.toUpperCase()}</div>
                                </div>

                                <hr />


                            </>
                        )
                    }

                    {mailingAddress && (
                        <>
                            <br></br>

                            <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                                <div className="col-xs-6" style={{ lineBreak: "anywhere" }}><strong>{t('review_summary.mailing_address')}</strong></div>
                            </div>
                            <hr />


                            <NewMailingAddressSummary isCivic={isCivic} />
                        </>
                    )}




                    {/* <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('contact_information.full_name')}</strong></div>
                        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{isCivic ? t('new_address.civic_address') : t('review_summary.home_address')}</div>
                    </div>
                    <hr />

                    <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('contact_information.phone_number')}</strong></div>
                        <div className="col-xs-6">{streetAddress} {apartment ? `${t('review_summary.unit')} ${apartment}` : ''}</div>
                    </div>

                    <hr />
                    <div className="row" style={{ display: 'flex', flexGrow: 1 }}>
                        <div className="col-xs-6"><strong>{t('contact_information.email')}</strong></div>
                        <div className="col-xs-6" style={{ lineBreak: "anywhere" }}>{email}</div>
                    </div>

                    <hr /> */}
                </div>
            </div>
        </div>

        //division
        // <div className="row">
        //     <div className="col-xs-12 col-lg-8">
        //             <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
        //                 <div style={{ flexGrow: 1 }}>
        //                     <div className="col">
        //                         <h2>{t('review_summary.new_address')}</h2>
        //                     </div>
        //                 </div>
        //                 <div className="col" style={{ display: 'flex', marginTop: "1rem", justifyContent: "flex-end", alignItems: "center" }}>
        //                     {/* <div className="col"> */}
        //                     {/* eslint-disable-next-line */}
        //                     <a href="#"
        //                         className={[styles['edit_button']].join(' ')}
        //                         onClick={editNewAddressOnClick}
        //                         value={t('jointly_owned_vehicle_summary.edit')}
        //                         name={t('jointly_owned_vehicle_summary.edit')}
        //                     >
        //                         {t('jointly_owned_vehicle_summary.edit')}
        //                     </a>
        //                     {/* </div> */}
        //                     {/* <div className="col-xs-1" /> */}
        //                 </div>
        //             </div >

        //             {
        //                 homeAddress && (
        //                     <>
        //                         <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
        //                             <div className="col" style={{ flexGrow: 1, backgroundColor: "lightgray" }}><strong>{isCivic ? t('new_address.civic_address') : t('review_summary.home_address')}</strong></div>
        //                             {/* <div style={{ flexGrow: 1 }} /> */}
        //                         </div>
        //                         <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
        //                             <div className="col" style={{ flexGrow: 1 }}>{streetAddress} {apartment ? `${t('review_summary.unit')} ${apartment}` : ''}</div>
        //                         </div>

        //                         <div className="row" style={{ display: 'flex', flexGrow: 1, }}>
        //                             <div className="col" style={{ flexGrow: 1 }}>{city}, {postalCode.toUpperCase()}</div>
        //                         </div>
        //                     </>
        //                 )
        //             }




        //     </div>
        // </div>
    )
}

export default withTranslation('common')(NewAddressSummary)
